import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    position: relative;
    display: flex;
    aspect-ratio: 12 / 5;
    background-color: ${COLORS.neutral_05};
`;

export const PlaceholderIcon = styled('div')`
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: ${COLORS.neutral_50};

    svg {
        width: 19%;
        height: auto;
        aspect-ratio: 1 / 1;
    }
`;

export const Image = styled('img')`
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`;
